<template>
  <div
    v-if="surveyId"
    id="survey"
  >
    <div class="survey-info">
      <h1>
        Loading survey...
      </h1>
    </div>
  </div>
  <div
    v-else
    class="survey-info"
  >
    <h1>
      No survey available.
    </h1>
    Thank you for your interest in providing feedback. Please check back again to participate.
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'surveyId'
    ])
  },
  mounted () {
    if (this.surveyId) {
      const pluginScript = document.createElement('script')
      pluginScript.setAttribute('src', 'https://touchpoints.app.cloud.gov/touchpoints/2d0c4ebd.js')
      pluginScript.async = true // Set to true if the script can be loaded asynchronously
      window.document.head.appendChild(pluginScript)
    }
  }
}
</script>

<style scoped>
.survey-info {
  padding: 20px 20px 20px 10px;
}

.survey-info h1 {
  font-size: 1.2em;
}
</style>
